import Vue from "vue";
import Cookie from "js-cookie";
import Router from "vue-router";
import store from "./store/index.js";
import PreOrder from "./views/PreOrder.vue";
import User from "./views/user/User.vue";
import Login from "./views/user/Login.vue";
import Register from "./views/user/Register.vue";
import ChangePwd from "./views/user/ChangePwd.vue";
import AddressBook from "./views/user/AddressBook.vue";
import Setting from "./views/user/Setting.vue";
import ForgotPwd from "./views/user/ForgotPwd";
import AddressList from "./views/address/AddressList.vue";
import EditAddress from "./views/address/EditAddress.vue";
import Suggestion from "./views/user/Suggestion.vue";
import MyOrder from "./views/order/MyOrder.vue";
import OrderDetail from "./views/order/OrderDetail.vue";
import ModifyOrder from "./views/order/ModifyOrder.vue";
import WayBill from "./views/order/WayBill.vue";
import WayBillDetail from "./views/order/WayBillDetail";
import Logistics from "./views/search/Logistics.vue";
import GoodsLogistics from "./views/search/GoodsLogistics";
import Dot from "./views/search/Dot.vue";
import LineSearch from "./views/search/Line.vue";
import CompanyProfile from "./views/search/CompanyProfile.vue";
import CompanySearch from "./views/search/CompnaySearch.vue";
import AllAddressList from "./views/address/AllAddressList.vue";
import Coupon from "./views/coupon/Coupon.vue";
import PushBinding from "./views/pushBinding/PushBinding.vue";
import PushInfo from "./views/pushBinding/BindingInfo.vue";
import Workman from "./views/user/Workman.vue";
import ShimaoWorkman from "./views/user/ShimaoWorkman.vue";
import HenanWorkman from './views/user/HenanWorkman.vue';

Vue.use(Router);

const router = new Router({
    routes: [
        // {
        //   path: "*",
        //   redirect: "/user"
        // },
        {
            path: "/",
            redirect: "/user"
        },
        {
            path: "/user",
            name: "User",
            component: User,
            meta: {
                requireAuth: true,
                title: "我的云企物流",
                hideBack: true
            }
        },
        {
            path: "/user/setting",
            name: "Setting",
            component: Setting,
            meta: {
                requireAuth: true,
                title: "设置",
                hideNav: true
            }
        },
        {
            path: "/preorder",
            name: "PreOrder",
            component: PreOrder,
            meta: {
                requireAuth: true,
                title: "预约寄件",
                hideBack: true,
                keepAlive: true
            }
        },
        {
            path: "/preorderhb",
            name: "PreOrder",
            component: PreOrder,
            meta: {
                requireAuth: true,
                title: "预约寄件",
                hideBack: true,
                keepAlive: true
            }
        },
        {
            path: "/coupon/invalid",
            name: "Coupon",
            component: Coupon,
            meta: {
                requireAuth: true,
                title: "失效红包",
                hideNav: true
            }
        },
        {
            path: "/order/myorder",
            name: "MyOrder",
            component: MyOrder,
            meta: {
                requireAuth: true,
                title: "我的订单",
                hideBack: false,
                keepAlive: true
            }
        },
        {
            path: "/order/waybill",
            name: "MyWayBill",
            component: WayBill,
            meta: {
                requireAuth: true,
                title: "我的运单",
                hideBack: true,
                keepAlive: true
            }
        },
        {
            path: "/order/waybilldetail",
            name: "WayBillDetail",
            component: WayBillDetail,
            meta: {
                requireAuth: true,
                title: "运单详情",
                hideBack: true
            }
        },
        {
            path: "/order/detail",
            name: "OrderDetail",
            component: OrderDetail,
            meta: {
                title: "订单详情",
                hideBack: false
            }
        },
        {
            path: "/order/modify/:id",
            name: "ModifyOrder",
            component: ModifyOrder,
            meta: {
                requireAuth: true,
                title: "订单修改",
                hideBack: true
            }
        },
        {
            path: "/search/logistics/:id",
            name: "Logistics",
            component: Logistics,
            meta: {
                title: "物流查询"
            }
        },
        {
            path: "/search/logistics",
            name: "LogisticsNormal",
            component: Logistics,
            meta: {
                title: "物流查询"
            }
        },
        {
            path: "/search/goodslogistics",
            name: "GoodsLogistics",
            component: GoodsLogistics,
            meta: {
                title: "货物查询",
                hideBack: true
            }
        },
        {
            path: "/search/dot",
            name: "Dot",
            component: Dot,
            meta: {
                title: "网点查询"
            }
        },
        {
            path: "/search/line",
            name: "LineSearch",
            component: LineSearch,
            meta: {
                title: "专线查询",
                keepAlive: true
            }
        },
        {
            path: "/search/company",
            name: "CompanySearch",
            component: CompanySearch,
            meta: {
                title: "物流公司查询",
                hideBack: true,
                keepAlive: true
            }
        },
        {
            path: "/search/companyprofile/:id",
            name: "CompanyProfile",
            component: CompanyProfile,
            meta: {
                title: "公司简介"
            }
        },
        {
            path: "/user/login",
            name: "Login",
            component: Login,
            meta: {
                title: "我的云企物流",
                hideNav: true,
                hideBack: true
            }
        },
        {
            path: "/user/register",
            name: "Register",
            component: Register,
            meta: {
                title: "我的云企物流",
                hideNav: true
            }
        },
        {
            path: "/user/changepwd",
            name: "ChangePwd",
            component: ChangePwd,
            meta: {
                requireAuth: true,
                title: "修改密码"
            }
        },
        {
            path: "/user/forgot",
            name: "ForgotPwd",
            component: ForgotPwd,
            meta: {
                title: "忘记密码",
                hideBack: true
            }
        },
        {
            path: "/user/addressbook",
            name: "AddressBook",
            component: AddressBook,
            meta: {
                requireAuth: true,
                title: "通讯录"
            }
        },
        {
            path: "/addresslist/:type",
            name: "AdressList",
            component: AddressList,
            meta: {
                requireAuth: true,
                title: "地址列表",
                hideNav: true
            }
        },
        {
            path: "/acceptAddressList",
            name: "AcceptAddressList",
            component: () => import('@/views/address/AcceptAddressList'),
            meta: {
                requireAuth: true,
                title: "收货人列表",
                hideNav: true
            }
        },
        {
            path: "/acceptAddressListMulti",
            name: "AcceptAddressListMulti",
            component: () => import('@/views/address/AcceptAddressList'),
            meta: {
                requireAuth: true,
                title: "收货人列表",
                hideNav: true
            }
        },
        {
            path: "/addresslist",
            name: "AllAddressList",
            component: AllAddressList,
            meta: {
                requireAuth: true,
                title: "地址列表",
                hideBack: true,
                hideNav: true,
                keepAlive: true
            }
        },
        {
            path: "/order/addresslist/:type/:id",
            name: "OrderAddressList",
            component: AddressList,
            meta: {
                requireAuth: true,
                title: "地址列表",
                hideNav: true
            }
        },
        {
            path: "/editaddress/:type/:id",
            name: "EditAddress",
            component: EditAddress,
            meta: {
                requireAuth: true,
                title: "编辑地址",
                hideNav: true
            }
        },
        {
            path: "/addaddress/:type",
            name: "AddAddress",
            component: EditAddress,
            meta: {
                requireAuth: true,
                title: "新增地址",
                hideNav: true
            }
        },
        {
            path: "/user/suggestion",
            name: "Suggestion",
            component: Suggestion,
            meta: {
                title: "投诉建议"
            }
        },
        {
            path: "/push/info/:mobile",
            name: "PushInfo",
            component: PushInfo,
            meta: {
                title: "我的云企物流",
                hideBack: true,
                hideNav: true
            }
        },
        {
            path: "/push/binding",
            name: "PushBinding",
            component: PushBinding,
            meta: {
                title: "我的云企物流",
                hideBack: true,
                hideNav: true
            }
        },
        {
            path: "/user/workman",
            name: "Workman",
            component: Workman,
            meta: {
                title: "沙河拉力君信息统一查询系统",
                requireAuth: false,
                hideBack: true,
                hideNav: true
            }
        },
        {
            path: "/user/shimaoWorkman",
            name: "ShimaoWorkman",
            component: ShimaoWorkman,
            meta: {
                title: "ARAapM拉力君信息统一查询系统",
                requireAuth: false,
                hideBack: true,
                hideNav: true
            }
        },
        {
            path: "/user/hnyqworkman",
            name: "HenanWorkman",
            component: HenanWorkman,
            meta: {
                title: "河南云企拉力君信息统一查询系统",
                requireAuth: false,
                hideBack: true,
                hideNav: true
            }
        },
        {
            path: "/order/push/detail",
            name: "PushOrderDetail",
            component: () => import('@/views/order/MyOrderDetail'),
            meta: {
                title: "订单详情",
                hideNav: true,
                hideBack: true,
                requireAuth: false
            }
        },
        {
            path: "/mailOrders",
            name: "mailOrders",
            component: () => import('@/views/mailOrders/mailOrders'),
            meta: {
                title: "下单寄件",
                hideNav: true,
                hideBack: true,
                requireAuth: false
            }
        },
        {
            path: "/organMap",
            name: "OrganMap",
            component: () => import("./views/organMap/OrganMap.vue"),
            meta: {
                title: "柯莱顺发铁马总部",
                requireAuth: false,
                hideBack: false,
                hideNav: true,
                keepAlive: true
            }
        },
        {
            path: "/search/branch",
            name: "Branch",
            component: () => import("./views/search/branch.vue"),
            meta: {
                title: "网点查询",
                keepAlive: true,
                hideBack: true,
                hideNav: false,
                requireAuth: false
            }
        }
    ]
});

if (localStorage.getItem("yhb_token") || Cookie.get("yhb_token")) {
    store.commit("getToken");
}

router.beforeEach((to, from, next) => {
    to.matched.forEach(r => {
        store.commit({
            type: "setTitle",
            title: r.meta.title
        });
        store.commit({
            type: "hideNav",
            flag: !r.meta.hideNav
        });
        store.commit({
            type: "hideBack",
            flag: !r.meta.hideBack
        });
    });
    if (to.matched.some(r => r.meta.requireAuth)) {
        if (store.state.token) {
            next();
        } else {
            next({
                path: "/user/login",
                query: {redirect: to.fullPath}
            });
        }
    } else {
        next();
    }
});

export default router;
